import { AdminResourceEditor } from "./AdminResourceEditor";

const FIELDS = [
  { name: "name", label: "Name" },
  { name: "title", label: "Title (e.g. Co-Founder & Head Coach)" },
  { name: "bio", label: "Bio", type: "textarea" },
  { name: "photo", label: "Photo", type: "image" },
  { name: "youtube_id", label: "YouTube Video ID", required: false },
  { name: "instagram", label: "Instagram URL", required: false },
  { name: "order", label: "Display Order", type: "number" },
];

const DEFAULTS = { name: "", title: "", bio: "", photo: "", youtube_id: "", instagram: "", order: 1 };

export default function AdminFounders() {
  return (
    <AdminResourceEditor
      resourceLabel="Founder"
      apiPath="/admin/founders"
      fields={FIELDS}
      defaultValues={DEFAULTS}
      renderItem={(item) => (
        <>
          <p className="text-cream truncate">{item.name}</p>
          <p className="text-smoke text-xs mt-1">{item.title}</p>
        </>
      )}
    />
  );
}
